var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[(_vm.loading)?[_c('v-progress-linear',{attrs:{"indeterminate":true}})]:_vm._e(),_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('pdf-export-panel',{ref:"pdfExport"}),_c('report-grid',{ref:"reportGrid"})],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }